<template>
    <div>
        <div class="prescription-section">
            <div class="row">
                <div class="col-12 mb-4 pl-4">
                    <div class="bg-white border-radius-5 p-4">
                        <div class="card-body bg-white border-radius-5 p-0 h-100">
                            <div class="d-flex justify-content-between align-items-center">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item pl-0"><a class="nav-link active" data-toggle="tab" href="#tabs-1" role="tab">Current Prescription </a></li>
                                    <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#tabs-2" role="tab">Past Prescription </a></li>
                                </ul>
                                <ul class="d-flex justify-content-end test-interaction">
                                    <li class="nav-item">
                                        <router-link class="nav-link Test-button border-radius-8" to="/drug-interaction"><i class="icon icon-medicine"></i>Test drug interaction</router-link >
                                    </li>
                                    <li class="nav-item">
                                        <router-link class="nav-link gray-button border-radius-8" to="/prescription-main"><i class="icon icon-plus"></i>Add New Prescription</router-link>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link gray-btn icon-area border-radius-8" href="#"><i class="icon icon-download"></i></a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link gray-btn icon-area border-radius-8" href="#"><i class="icon icon-mail"></i></a>
                                    </li>
                                </ul>
                            </div>
                            <!-- Tab panes -->
                            <div class="tab-content">
                                <div class="tab-pane active" id="tabs-1" role="tabpanel">
                                    <div class="row no-gutters d-flex justify-content-between align-items-center w-100">
                                        <div class="d-flex justify-content-between align-items-center w-100 border-top py-3 Current">
                                            <div class="Program d-flex align-items-center">
                                                <i class="icon icon-prescription"></i>
                                                <div class="Diebetes">
                                                    <h6>Program</h6>
                                                    <p>Diebetes</p>
                                                </div>
                                            </div>
                                            <div class="dr-history d-flex">
                                                <figure class="mb-0 mr-3"><img src="../../../../static/website/images/dr-image.svg" alt="" /></figure>
                                                <div class="dr-history">
                                                    <h6>Name</h6>
                                                    <h3>Dr. Shabnam Das Kar</h3>
                                                    <p>Registration No.: 84676 (Maharashtra Medical Council)</p>
                                                </div>
                                            </div>
                                            <div class="intake">
                                                <router-link to="/prescription-with-medicine">
                                                    <h6>Date</h6>
                                                    <p>13 May 2021, to 13 June 2021</p>
                                                </router-link >
                                            </div>
                                            <div class="Reschedule d-flex">
                                                <a href="#" class="btn"><i class="icon icon-x-octagon"></i></a>
                                                <router-link to="/prescription-main" class="btn"><i class="icon icon-refresh"></i></router-link >
                                                <router-link to="/prescription-medicine-order" class="btn"><i class="icon icon-shopping-bag"></i></router-link >
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center w-100 border-top py-3 Current">
                                            <div class="Program d-flex align-items-center">
                                                <i class="icon icon-prescription"></i>
                                                <div class="Diebetes">
                                                    <h6>Program</h6>
                                                    <p>Diebetes</p>
                                                </div>
                                            </div>
                                            <div class="dr-history d-flex">
                                                <figure class="mb-0 mr-3"><img src="../../../../static/website/images/dr-image.svg" alt="" /></figure>
                                                <div class="dr-history">
                                                    <h6>Name</h6>
                                                    <h3>Dr. Shabnam Das Kar</h3>
                                                    <p>Registration No.: 84676 (Maharashtra Medical Council)</p>
                                                </div>
                                            </div>
                                            <div class="intake">
                                                <router-link to="/prescription-with-medicine">
                                                    <h6>Date</h6>
                                                    <p>13 May 2021, to 13 June 2021</p>
                                                </router-link>
                                            </div>
                                            <div class="Reschedule d-flex">
                                                <a href="#" class="btn"><i class="icon icon-x-octagon"></i></a>
                                                <router-link to="/prescription-main" class="btn"><i class="icon icon-refresh"></i></router-link>
                                                <router-link to="/prescription-medicine-order" class="btn"><i class="icon icon-shopping-bag"></i></router-link>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center w-100 border-top py-3 Current">
                                            <div class="Program d-flex align-items-center">
                                                <i class="icon icon-prescription"></i>
                                                <div class="Diebetes">
                                                    <h6>Program</h6>
                                                    <p>Diebetes</p>
                                                </div>
                                            </div>
                                            <div class="dr-history d-flex">
                                                <figure class="mb-0 mr-3"><img src="../../../../static/website/images/dr-image.svg" alt="" /></figure>
                                                <div class="dr-history">
                                                    <h6>Name</h6>
                                                    <h3>Dr. Shabnam Das Kar</h3>
                                                    <p>Registration No.: 84676 (Maharashtra Medical Council)</p>
                                                </div>
                                            </div>
                                            <div class="intake">
                                                <router-link to="/prescription-with-medicine">
                                                    <h6>Date</h6>
                                                    <p>13 May 2021, to 13 June 2021</p>
                                                </router-link>
                                            </div>
                                            <div class="Reschedule d-flex">
                                                <a href="#" class="btn"><i class="icon icon-x-octagon"></i></a>
                                                <router-link to="/prescription-main" class="btn"><i class="icon icon-refresh"></i></router-link>
                                                <router-link to="/prescription-medicine-order" class="btn"><i class="icon icon-shopping-bag"></i></router-link>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center w-100 border-top py-3 Current">
                                            <div class="Program d-flex align-items-center">
                                                <i class="icon icon-prescription"></i>
                                                <div class="Diebetes">
                                                    <h6>Program</h6>
                                                    <p>Diebetes</p>
                                                </div>
                                            </div>
                                            <div class="dr-history d-flex">
                                                <figure class="mb-0 mr-3"><img src="../../../../static/website/images/dr-image.svg" alt="" /></figure>
                                                <div class="dr-history">
                                                    <h6>Name</h6>
                                                    <h3>Dr. Shabnam Das Kar</h3>
                                                    <p>Registration No.: 84676 (Maharashtra Medical Council)</p>
                                                </div>
                                            </div>
                                            <div class="intake">
                                                <router-link to="/prescription-with-medicine">
                                                    <h6>Date</h6>
                                                    <p>13 May 2021, to 13 June 2021</p>
                                                </router-link>
                                            </div>
                                            <div class="Reschedule d-flex">
                                                <a href="#" class="btn"><i class="icon icon-x-octagon"></i></a>
                                                <router-link to="/prescription-main" class="btn"><i class="icon icon-refresh"></i></router-link>
                                                <router-link to="/prescription-medicine-order" class="btn"><i class="icon icon-shopping-bag"></i></router-link>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center w-100 border-top py-3 Current">
                                            <div class="Program d-flex align-items-center">
                                                <i class="icon icon-prescription"></i>
                                                <div class="Diebetes">
                                                    <h6>Program</h6>
                                                    <p>Diebetes</p>
                                                </div>
                                            </div>
                                            <div class="dr-history d-flex">
                                                <figure class="mb-0 mr-3"><img src="../../../../static/website/images/dr-image.svg" alt="" /></figure>
                                                <div class="dr-history">
                                                    <h6>Name</h6>
                                                    <h3>Dr. Shabnam Das Kar</h3>
                                                    <p>Registration No.: 84676 (Maharashtra Medical Council)</p>
                                                </div>
                                            </div>
                                            <div class="intake">
                                                <router-link to="/prescription-with-medicine">
                                                    <h6>Date</h6>
                                                    <p>13 May 2021, to 13 June 2021</p>
                                                </router-link>
                                            </div>
                                            <div class="Reschedule d-flex">
                                                <a href="#" class="btn"><i class="icon icon-x-octagon"></i></a>
                                                <router-link to="/prescription-main" class="btn"><i class="icon icon-refresh"></i></router-link>
                                                <router-link to="/prescription-medicine-order" class="btn"><i class="icon icon-shopping-bag"></i></router-link>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center w-100 border-top py-3 Current">
                                            <div class="Program d-flex align-items-center">
                                                <i class="icon icon-prescription"></i>
                                                <div class="Diebetes">
                                                    <h6>Program</h6>
                                                    <p>Diebetes</p>
                                                </div>
                                            </div>
                                            <div class="dr-history d-flex">
                                                <figure class="mb-0 mr-3"><img src="../../../../static/website/images/dr-image.svg" alt="" /></figure>
                                                <div class="dr-history">
                                                    <h6>Name</h6>
                                                    <h3>Dr. Shabnam Das Kar</h3>
                                                    <p>Registration No.: 84676 (Maharashtra Medical Council)</p>
                                                </div>
                                            </div>
                                            <div class="intake">
                                                <router-link to="/prescription-with-medicine">
                                                    <h6>Date</h6>
                                                    <p>13 May 2021, to 13 June 2021</p>
                                                </router-link>
                                            </div>
                                            <div class="Reschedule d-flex">
                                                <a href="#" class="btn"><i class="icon icon-x-octagon"></i></a>
                                                <router-link to="/prescription-main" class="btn"><i class="icon icon-refresh"></i></router-link>
                                                <router-link to="/prescription-medicine-order" class="btn"><i class="icon icon-shopping-bag"></i></router-link>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center w-100 border-top py-3 Current">
                                            <div class="Program d-flex align-items-center">
                                                <i class="icon icon-prescription"></i>
                                                <div class="Diebetes">
                                                    <h6>Program</h6>
                                                    <p>Diebetes</p>
                                                </div>
                                            </div>
                                            <div class="dr-history d-flex">
                                                <figure class="mb-0 mr-3"><img src="../../../../static/website/images/dr-image.svg" alt="" /></figure>
                                                <div class="dr-history">
                                                    <h6>Name</h6>
                                                    <h3>Dr. Shabnam Das Kar</h3>
                                                    <p>Registration No.: 84676 (Maharashtra Medical Council)</p>
                                                </div>
                                            </div>
                                            <div class="intake">
                                                <router-link to="/prescription-with-medicine">
                                                    <h6>Date</h6>
                                                    <p>13 May 2021, to 13 June 2021</p>
                                                </router-link>
                                            </div>
                                            <div class="Reschedule d-flex">
                                                <a href="#" class="btn"><i class="icon icon-x-octagon"></i></a>
                                                <router-link to="/prescription-main" class="btn"><i class="icon icon-refresh"></i></router-link>
                                                <router-link to="/prescription-medicine-order" class="btn"><i class="icon icon-shopping-bag"></i></router-link>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center w-100 border-top py-3 Current">
                                            <div class="Program d-flex align-items-center">
                                                <i class="icon icon-prescription"></i>
                                                <div class="Diebetes">
                                                    <h6>Program</h6>
                                                    <p>Diebetes</p>
                                                </div>
                                            </div>
                                            <div class="dr-history d-flex">
                                                <figure class="mb-0 mr-3"><img src="../../../../static/website/images/dr-image.svg" alt="" /></figure>
                                                <div class="dr-history">
                                                    <h6>Name</h6>
                                                    <h3>Dr. Shabnam Das Kar</h3>
                                                    <p>Registration No.: 84676 (Maharashtra Medical Council)</p>
                                                </div>
                                            </div>
                                            <div class="intake">
                                                <router-link to="/prescription-with-medicine">
                                                    <h6>Date</h6>
                                                    <p>13 May 2021, to 13 June 2021</p>
                                                </router-link>
                                            </div>
                                            <div class="Reschedule d-flex">
                                                <a href="#" class="btn"><i class="icon icon-x-octagon"></i></a>
                                                <router-link to="/prescription-main" class="btn"><i class="icon icon-refresh"></i></router-link>
                                                <router-link to="/prescription-medicine-order" class="btn"><i class="icon icon-shopping-bag"></i></router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane" id="tabs-2" role="tabpanel">
                                    <div class="d-flex justify-content-between align-items-center w-100 border-top py-3 Current">
                                        <div class="Program d-flex align-items-center">
                                            <i class="icon icon-prescription"></i>
                                            <div class="Diebetes">
                                                <h6>Program</h6>
                                                <p>Diebetes</p>
                                            </div>
                                        </div>
                                        <div class="dr-history d-flex">
                                            <figure class="mb-0 mr-3"><img src="../../../../static/website/images/dr-image.svg" alt="" /></figure>
                                            <div class="dr-history">
                                                <h6>Name</h6>
                                                <h3>Dr. Shabnam Das Kar</h3>
                                                <p>Registration No.: 84676 (Maharashtra Medical Council)</p>
                                            </div>
                                        </div>
                                        <div class="intake">
                                            <a href="#">
                                                <h6>Date</h6>
                                                <p>13 May 2021, to 13 June 2021</p>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center w-100 border-top py-3 Current">
                                        <div class="Program d-flex align-items-center">
                                            <i class="icon icon-prescription"></i>
                                            <div class="Diebetes">
                                                <h6>Program</h6>
                                                <p>Diebetes</p>
                                            </div>
                                        </div>
                                        <div class="dr-history d-flex">
                                            <figure class="mb-0 mr-3"><img src="../../../../static/website/images/dr-image.svg" alt="" /></figure>
                                            <div class="dr-history">
                                                <h6>Name</h6>
                                                <h3>Dr. Shabnam Das Kar</h3>
                                                <p>Registration No.: 84676 (Maharashtra Medical Council)</p>
                                            </div>
                                        </div>
                                        <div class="intake">
                                            <h6>Date</h6>
                                            <p>13 May 2021, to 13 June 2021</p>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center w-100 border-top py-3 Current">
                                        <div class="Program d-flex align-items-center">
                                            <i class="icon icon-prescription"></i>
                                            <div class="Diebetes">
                                                <h6>Program</h6>
                                                <p>Diebetes</p>
                                            </div>
                                        </div>
                                        <div class="dr-history d-flex">
                                            <figure class="mb-0 mr-3"><img src="../../../../static/website/images/dr-image.svg" alt="" /></figure>
                                            <div class="dr-history">
                                                <h6>Name</h6>
                                                <h3>Dr. Shabnam Das Kar</h3>
                                                <p>Registration No.: 84676 (Maharashtra Medical Council)</p>
                                            </div>
                                        </div>
                                        <div class="intake">
                                            <h6>Date</h6>
                                            <p>13 May 2021, to 13 June 2021</p>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center w-100 border-top py-3 Current">
                                        <div class="Program d-flex align-items-center">
                                            <i class="icon icon-prescription"></i>
                                            <div class="Diebetes">
                                                <h6>Program</h6>
                                                <p>Diebetes</p>
                                            </div>
                                        </div>
                                        <div class="dr-history d-flex">
                                            <figure class="mb-0 mr-3"><img src="../../../../static/website/images/dr-image.svg" alt="" /></figure>
                                            <div class="dr-history">
                                                <h6>Name</h6>
                                                <h3>Dr. Shabnam Das Kar</h3>
                                                <p>Registration No.: 84676 (Maharashtra Medical Council)</p>
                                            </div>
                                        </div>
                                        <div class="intake">
                                            <h6>Date</h6>
                                            <p>13 May 2021, to 13 June 2021</p>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center w-100 border-top py-3 Current">
                                        <div class="Program d-flex align-items-center">
                                            <i class="icon icon-prescription"></i>
                                            <div class="Diebetes">
                                                <h6>Program</h6>
                                                <p>Diebetes</p>
                                            </div>
                                        </div>
                                        <div class="dr-history d-flex">
                                            <figure class="mb-0 mr-3"><img src="../../../../static/website/images/dr-image.svg" alt="" /></figure>
                                            <div class="dr-history">
                                                <h6>Name</h6>
                                                <h3>Dr. Shabnam Das Kar</h3>
                                                <p>Registration No.: 84676 (Maharashtra Medical Council)</p>
                                            </div>
                                        </div>
                                        <div class="intake">
                                            <h6>Date</h6>
                                            <p>13 May 2021, to 13 June 2021</p>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center w-100 border-top py-3 Current">
                                        <div class="Program d-flex align-items-center">
                                            <i class="icon icon-prescription"></i>
                                            <div class="Diebetes">
                                                <h6>Program</h6>
                                                <p>Diebetes</p>
                                            </div>
                                        </div>
                                        <div class="dr-history d-flex">
                                            <figure class="mb-0 mr-3"><img src="../../../../static/website/images/dr-image.svg" alt="" /></figure>
                                            <div class="dr-history">
                                                <h6>Name</h6>
                                                <h3>Dr. Shabnam Das Kar</h3>
                                                <p>Registration No.: 84676 (Maharashtra Medical Council)</p>
                                            </div>
                                        </div>
                                        <div class="intake">
                                            <h6>Date</h6>
                                            <p>13 May 2021, to 13 June 2021</p>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center w-100 border-top py-3 Current">
                                        <div class="Program d-flex align-items-center">
                                            <i class="icon icon-prescription"></i>
                                            <div class="Diebetes">
                                                <h6>Program</h6>
                                                <p>Diebetes</p>
                                            </div>
                                        </div>
                                        <div class="dr-history d-flex">
                                            <figure class="mb-0 mr-3"><img src="../../../../static/website/images/dr-image.svg" alt="" /></figure>
                                            <div class="dr-history">
                                                <h6>Name</h6>
                                                <h3>Dr. Shabnam Das Kar</h3>
                                                <p>Registration No.: 84676 (Maharashtra Medical Council)</p>
                                            </div>
                                        </div>
                                        <div class="intake">
                                            <h6>Date</h6>
                                            <p>13 May 2021, to 13 June 2021</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "stop-medicine-delivery",
        data() {
            return {};
        },
        created(){
           this.pageName('Prescription')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/medicines/stop-medicine-delivery.vue